import { action } from 'satcheljs';

/**
 * Action to update current settings saving status in the store.
 */
const setIsSaving = action('SET_IS_SAVING_PBP_SETTINGS', (isSaving: boolean) => ({
    isSaving,
}));

/**
 * Action to update isTurningOnBookingPage status in the store.
 */
export const setIsTurningOnBookingPage = action(
    'setIsTurningOnBookingPage',
    (isTurningOnBookingPage: boolean) => ({
        isTurningOnBookingPage,
    })
);

export default setIsSaving;
